import { api } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/favorites',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    return e
  }
}

export async function saveFavorite(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: '/favorites',
      data: queryParams,
      method: 'POST'
    })
    return response
  } catch (e) {
    return e
  }
}

export async function remove(ctx, queryParams = {}) {
  try {
    const response = await api({
      url: parseUrl('favorites', queryParams),
      data: queryParams,
      method: 'DELETE'
    })
    return response
  } catch (e) {
    return e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return `/${state}/${params.id}`
  }
  return `/${state}`
}
